import React, { Component } from 'react';
import {
  inject,
  observer,
} from 'mobx-react';
import ReactTable from 'react-table';
import {
  Col,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import Filters from '../../components/Filters/Filters';
import PaginationTable from '../../components/Pagination/PaginationTable';
import getSortHeaderProps from '../../utils/get-sorted-headers';
import { showConfirmModal } from '../../modules/modals/confirmService';
import { withTranslation } from 'react-i18next';
import logger from '../../utils/logger';

class SlumpTableList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sorted: [{id: 'code', desc: false}],
      filter: '',
    };
  }

  componentDidMount() {
    const { slumpTableStore } = this.props;
    if (!slumpTableStore.slumpTables.length) {
      slumpTableStore.fetchSlumpTables();
    }
  }

  onEdit = id => {
    const { slumpTableStore, onEdit } = this.props;
    slumpTableStore.setSlumpTableId(id);
    onEdit();
  };

  onDelete = (id) => {
    const { slumpTableStore, notifierStore, onDelete, t } = this.props;

    return showConfirmModal({
      title: `${t('Are you sure you want to delete this slump table')} #${id}?`,
      okLabel: t('Yes'),
      cancelLabel: t('No'),
      enableEscape: false,
    })
      .then(() => {
        onDelete();
        slumpTableStore.removeSlumpTable(id)
          .then(() => {
            slumpTableStore.setSlumpTableId(null);
            slumpTableStore.fetchSlumpTables();
          })
          .catch((e) => {
            logger.error(e);
            notifierStore.showError(`Couldn't remove Slump Table ${e?.message}`);
          });
      })
      .catch(() => {});
  };

  getColumns = () => {
    const { sorted } = this.state;
    const { t } = this.props;

    return [
      {
        headerText: t('Code'),
        accessor: 'code',
        id: 'code',
        className: 'sticky',
        headerClassName: 'sticky',
        ...getSortHeaderProps(sorted),
        maxWidth: 200,
      },
      {
        headerText: t('Description'),
        accessor: 'description',
        id: 'description',
        ...getSortHeaderProps(sorted),
      },
      {
        accessor: 'actions',
        maxWidth: 120,
        Cell: row => (
          <div className="text-right">
            <a className="btn btn-sm btn-default btn-action"
              title="Edit"
              onClick={() => this.onEdit(row.original.id)}>
              <i className="fa fa-pencil"/>
            </a>
            <a className="btn btn-sm btn-default btn-action"
              title="Remove"
              onClick={() => this.onDelete(row.original.id)}>
              <i className="fa fa-remove"/>
            </a>
          </div>
        ),
      },
    ];
  };

  handleChange = (e) => {
    const filter = e.target.value;
    this.setState({ filter });
  };

  render() {
    const { slumpTableStore, t } = this.props;
    const { slumpTables } = slumpTableStore;
    const { filter } = this.state;

    return (
      <div className={`slump-table-list-${slumpTables?.length}`}>
        <Col sm={4} xs={10} className={'no-padding'}>
          <FormGroup>
            <FormControl
              type="text"
              value={filter}
              placeholder={t('Search')}
              onChange={this.handleChange}
            />
          </FormGroup>
        </Col>
        <Filters filter={filter} data={slumpTables} renderData={(items) => (
          <ReactTable
            className="-highlight slump-table"
            data={items}
            columns={this.getColumns()}
            sorted={this.state.sorted}
            onSortedChange={sorted => this.setState({ sorted })}
            showPaginationTop={false}
            showPaginationBottom={true}
            showPageSizeOptions={true}
            PaginationComponent={PaginationTable}
            resizable={false}
            minRows={1}
            defaultPageSize={100}
            getTrProps={(state, rowInfo) => {
              if (rowInfo && rowInfo.row) {
                return {
                  onClick: () => {
                    this.onEdit(rowInfo.original.id);
                    this.setState({
                      selected: rowInfo.index,
                    });
                  },
                  className: rowInfo.index === this.state.selected ? 'row-selected': '',
                };
              }
              return {};
            }}
          />
        )} />
      </div>
    );
  }
}

export default withTranslation()(inject('slumpTableStore', 'notifierStore')(observer(SlumpTableList)));
